
<template>
    <div class="modal cancel-modal">
        <div class="modal-title hide-on-minimized">
            New Settings
            <div class="countdown-wrapper">
                <circular-countdown :durationInSeconds="30" :startTime="startTime" />
            </div>
        </div>
        <div class="modal-content">
            <div class="modal-description">
                <p>
                    The game settings have recently changed.
                </p>
                <p>
                    Please confirm the new settings:
                </p>
                <settings-summary :gameState="gameState" :smallerText="true" />
            </div>
            <div class="options">
                <button class="btn btn-muted btn-small btn-3d" @click="onCancelMatch()">
                    Cancel Game
                </button>
                <button class="btn btn-primary btn-small btn-3d" @click="onCloseModal()">
                    Confirm & Play
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['gameState', 'onCloseModal'],
    name: 'CancelModal',
    created() {
        this.timeout = setTimeout(() => {
            this.onCloseModal();
        }, 30000);
    },
    beforeUnmount() {
        clearTimeout(this.timeout);
    },
    data() {
        return {
            timeout: null,
        };
    },
    computed: {
        startTime() {
            return moment();
        },
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
    },
    methods: {
        async onCancelMatch() {
            await this.$store.dispatch('cancelMatch', this.gameId);
        },
    },
};
</script>


<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .modal {

        &.cancel-modal {
            padding: 20px;

            .modal-title {
                color: $green;
            }

            .modal-description {
                font-size: .9rem;
            }

            .btn {
                margin: auto 12.5px;
            }

            .unit-img {
                cursor: pointer;
                height: 65px;
                width: 65px;
                margin: auto 7.5px;
            }

            .options {
                display: flex;
                justify-content: center;

                > * {
                    align-self: center;
                }
            }

            .countdown-wrapper {
                color: black;
                left: 0;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

</style>
